export default function normalizeEvent(event) {
  if (event.payload) {
    event.payload = JSON.parse(event.payload);
    if (event.payload.imageSize) {
      const [width, height] = event.payload.imageSize.split("x");
      event.mediaRatio = width / height;
      event.mediaWidth = width;
      event.mediaHeight = height;
    }
  }
}
